import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../public/scss/feedComponent.scss";

import Chart from "react-apexcharts";

// import { sendLoginCredentials, getParetQuestions, submitFormNow } from './../actions/formActions';
import { connect } from "react-redux";
// import { getUserData, logOut } from './../actions/utility';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Button,
  Container,
  Row,
  Media,
  Col,
  Progress,
  Spinner,
  Alert,
  DropdownItem,
  DropdownToggle,
  Dropdown,
  DropdownMenu,
  // NavLink
} from "reactstrap";

import NotificationsComponent from "../notifications/NotificationsComponent";
import emptyUserImg from "../../public/images/emptyuserphoto.png";
import emptyUserImg2 from "../../public/images/empty.svg";
import playBtn from "../../public/images/playBtn.png";
import UpdateStudentImage from "./UpdateStudentImage";
import $ from "jquery";

class SideProfileComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInfo: false,
      studentBasicInfo: {},
      isPreviewMobile: false,
      assignedPrograms: [],
      assignedNotifications: [],
      last: "",
      candidate: {
        feeds: 0,
        worksheet: 0,
      },
      tagLabels1: ["A", "B", "C", "D", "F"],
      tagLabels2: ["Inadequate", "Marginal", "Adequate", "Good", "Excellent"],
      tagLabels3: ["1 Star", "2 Stars", "3 Stars", "4 Stars", "5 Stars"],
      options1: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
        },
        colors: ["#007b5f", "#54b025", "#d9dc00", "#ff950a", "#ff0300"],
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: "40%",
            // endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["Performance"],
        },
        // yaxis: {
        //     title: {
        //         text: '$ (thousands)'
        //     }
        // },
        fill: {
          opacity: 1,
        },
        legend: {
          // position: 'bottom',
          horizontalAlign: "left",
          // offsetX: 1,
          offsetY: -12,
        },
        // tooltip: {
        //     y: {
        //         formatter: function (val) {
        //             return "$ " + val + " thousands"
        //         }
        //     }
        // }
      },
      options2: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
        },
        colors: ["#ff0300", "#ff950a", "#0a55de", "#54b025", "#007b5f"],
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: "40%",
            // endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["Understanding"],
        },
        // yaxis: {
        //     title: {
        //         text: '$ (thousands)'
        //     }
        // },
        fill: {
          opacity: 1,
        },
        legend: {
          // position: 'bottom',
          horizontalAlign: "left",
          // offsetX: 1,
          offsetY: -12,
        },
        // tooltip: {
        //     y: {
        //         formatter: function (val) {
        //             return "$ " + val + " thousands"
        //         }
        //     }
        // }
      },
      options3: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
        },
        colors: ["#ff0300", "#ff950a", "#0a55de", "#54b025", "#007b5f"],
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: "40%",
            // endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["Effort"],
        },
        // yaxis: {
        //     title: {
        //         text: '$ (thousands)'
        //     }
        // },
        fill: {
          opacity: 1,
        },
        legend: {
          // position: 'bottom',
          horizontalAlign: "left",
          // offsetX: 1,
          offsetY: -12,
        },
        // tooltip: {
        //     y: {
        //         formatter: function (val) {
        //             return "$ " + val + " thousands"
        //         }
        //     }
        // }
      },
      series1: [],
      series2: [],
      series3: [],
    };
  }

  componentWillReceiveProps(nextProps, thisProps) {
    console.log("NextProps", nextProps);

    if (nextProps.data) {
      var student = nextProps.data;
      var studentImage = "";
      if (student.image && student.image != null) {
        studentImage =
          "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/" +
          student.image;
      }
      this.setState({
        studentBasicInfo: {
          thumb: studentImage,
          name: student.user_name,
          grade: "",
          email: student.user_email,
          institute: student.institute_name,
          studentId: student.id,
        },
      });
    }

    if (nextProps.programs) {
      this.setState({
        assignedPrograms: nextProps.programs,
      });
    }

    if (nextProps.notifications) {
      this.setState(
        {
          assignedNotifications: nextProps.notifications,
        },
        () => {
          console.log(this.state.assignedNotifications);
        }
      );
    }

    if (nextProps.candidateGrade) {
      var studentTempInfo = this.state.studentBasicInfo;
      studentTempInfo.grade = nextProps.candidateGrade;
      this.setState({
        studentBasicInfo: studentTempInfo,
      });
    }

    if (nextProps.lastUpdate) {
      this.setState({
        last: nextProps.lastUpdate,
      });
    }

    if (this.props.statsData != nextProps.statsData) {
      // var inappropriate = 0, marginal = 0, adequate = 0, good = 0, excellent = 0;
      if (nextProps.statsData.data && nextProps.statsData.data.length) {
        this.setState({
          candidate: {
            feeds: nextProps.statsData.data.length,
            worksheet: 0,
          },
        });

        var feedsData = nextProps.statsData.data;

        var performanceArray = {};
        var understandingArray = {};
        var enthusiasmArray = {};

        feedsData &&
          feedsData.length &&
          feedsData.map((feed) => {
            var data = JSON.parse(feed.feed_data);
            // console.log(data);
            var value;

            if (performanceArray[data.feed_performance.label] != undefined) {
              value = performanceArray[data.feed_performance.label];
              value++;
              performanceArray[data.feed_performance.label] = value;
            } else {
              value = 1;
              performanceArray[data.feed_performance.label] = value;
            }

            if (
              understandingArray[data.feed_comprehension.label] != undefined
            ) {
              value = understandingArray[data.feed_comprehension.label];
              value++;
              understandingArray[data.feed_comprehension.label] = value;
            } else {
              value = 1;
              understandingArray[data.feed_comprehension.label] = value;
            }

            if (enthusiasmArray[data.feed_willingness.label] != undefined) {
              value = enthusiasmArray[data.feed_willingness.label];
              value++;
              enthusiasmArray[data.feed_willingness.label] = value;
            } else {
              value = 1;
              enthusiasmArray[data.feed_willingness.label] = value;
            }
          });

        var seriesArray1 = [];
        var seriesArray2 = [];
        var seriesArray3 = [];
        this.state.tagLabels1.map((tag) => {
          var checkTag = performanceArray[tag];
          if (tag == "A") {
            checkTag = performanceArray["Inadequate"];
          }
          if (tag == "B") {
            checkTag = performanceArray["Marginal"];
          }
          if (tag == "C") {
            checkTag = performanceArray["Adequate"];
          }
          if (tag == "D") {
            checkTag = performanceArray["Good"];
          }
          if (tag == "F") {
            checkTag = performanceArray["Excellent"];
          }
          // 'Inadequate', 'Marginal', 'Adequate', 'Good', 'Excellent'
          seriesArray1.push({
            name: tag,
            data: [
              checkTag != undefined ? checkTag : 0,
              // understandingArray[tag] != undefined ? understandingArray[tag] : 0,
              // enthusiasmArray[tag] != undefined ? enthusiasmArray[tag] : 0
            ],
          });
        });

        this.state.tagLabels2.map((tag) => {
          seriesArray2.push({
            name: tag,
            data: [
              // performanceArray[tag] != undefined ? performanceArray[tag] : 0,
              understandingArray[tag] != undefined
                ? understandingArray[tag]
                : 0,
              // enthusiasmArray[tag] != undefined ? enthusiasmArray[tag] : 0
            ],
          });
        });

        this.state.tagLabels3.map((tag) => {
          var checkTag = enthusiasmArray[tag];
          if (tag == "1 Star") {
            checkTag = enthusiasmArray["Inadequate"];
          }
          if (tag == "2 Stars") {
            checkTag = enthusiasmArray["Marginal"];
          }
          if (tag == "3 Stars") {
            checkTag = enthusiasmArray["Adequate"];
          }
          if (tag == "4 Stars") {
            checkTag = enthusiasmArray["Good"];
          }
          if (tag == "5 Stars") {
            checkTag = enthusiasmArray["Excellent"];
          }
          seriesArray3.push({
            name: tag,
            data: [
              // performanceArray[tag] != undefined ? performanceArray[tag] : 0,
              // understandingArray[tag] != undefined ? understandingArray[tag] : 0,
              checkTag != undefined ? checkTag : 0,
            ],
          });
        });

        this.setState(
          {
            series1: seriesArray1,
            series2: seriesArray2,
            series3: seriesArray3,
          },
          () => {
            // console.log(this.state.series1);
            // console.log(this.state.series2);
            // console.log(this.state.series3);
          }
        );
      }
    }

    if (nextProps.type) {
      if (nextProps.type == "info") {
        this.setState({
          isInfo: true,
        });
      } else {
        this.setState({
          isInfo: false,
        });
      }
    }

    if (this.props.isPreview != nextProps.isPreview) {
      this.setState({
        isPreviewMobile: nextProps.isPreview,
      });
    }
  }

  componentDidMount() {
    if (this.props.type == "info") {
      this.setState({
        isInfo: true,
      });
    }
  }

  componentWillUnmount() {}

  handleModalShow = () => {
    $("#myModalWait").modal("show");
  };

  render() {
    console.log("studentBasicInfo", this.state.studentBasicInfo);
    const { candidate, studentBasicInfo } = this.state;

    var total = candidate.worksheet + candidate.feeds;
    const worksheets = (candidate.worksheet / total) * 100;
    const feeds = (candidate.feeds / total) * 100;

    return (
      <>
        <div
          className={
            !this.state.isInfo
              ? this.state.isPreviewMobile
                ? "profileContainer information preview"
                : "profileContainer information hide"
              : "profileContainer"
          }
        >
          {this.state.isInfo ? (
            <Row>
              {studentBasicInfo.name ? (
                <Col md={{ size: 12 }}>
                  <div className="d-flex justify-content-center">
                    <div
                      className="candidateImage"
                      onClick={() => this.handleModalShow()}
                    >
                      <Media
                        src={
                          studentBasicInfo.thumb && studentBasicInfo.thumb != ""
                            ? studentBasicInfo.thumb
                            : emptyUserImg2
                        }
                      />
                    </div>
                    <div>
                      <UpdateStudentImage
                        handleModalShow={this.handleModalShow}
                        studentId={studentBasicInfo?.studentId}
                        studentImage={
                          studentBasicInfo.thumb != ""
                            ? studentBasicInfo.thumb
                            : "https://feeds.lincolnmethod.com/static/media/empty.23b93484.svg"
                        }
                      />
                    </div>
                    {/* <h5 className="">{studentBasicInfo.name}</h5> */}
                  </div>
                  {/* <p style={{fontSize: '14px'}}>{studentBasicInfo.email}</p> */}
                  {studentBasicInfo.grade != "" ? (
                    <p style={{ fontSize: "14px", marginBottom: "7px" }}>
                      {studentBasicInfo.grade}
                    </p>
                  ) : null}
                  {studentBasicInfo.institute != null &&
                  studentBasicInfo.institute != "" ? (
                    <p style={{ fontSize: "12px" }}>
                      {studentBasicInfo.institute}
                    </p>
                  ) : null}
                  {/* <hr/> */}
                  {this.state.assignedPrograms &&
                  this.state.assignedPrograms.length ? (
                    <div>
                      <p
                        style={{
                          fontSize: "12px",
                          textAlign: "left",
                          marginBottom: "10px",
                        }}
                      >
                        <strong>{studentBasicInfo.name} enrolled in:</strong>
                      </p>

                      <ul
                        style={{
                          paddingLeft: "20px",
                          fontSize: "12px",
                          textAlign: "left",
                        }}
                      >
                        {this.state.assignedPrograms.map((progarm, key) => (
                          <li key={key}>
                            {progarm.coursename
                              ? progarm.coursename
                              : progarm.prog_name}
                          </li>
                        ))}
                      </ul>
                      {/* <hr/> */}
                    </div>
                  ) : null}
                  {this.state.last != "" ? (
                    <p
                      style={{
                        textAlign: "left",
                        fontSize: "12px",
                        margin: "0",
                      }}
                    >
                      <strong>Last Update: </strong>
                      <span
                        dangerouslySetInnerHTML={{ __html: this.state.last }}
                      ></span>
                    </p>
                  ) : null}
                </Col>
              ) : (
                <div style={{ display: "block", height: "300px" }}></div>
              )}
              {this.state.assignedNotifications &&
              this.state.assignedNotifications.length ? (
                <NotificationsComponent
                  notifications={this.state.assignedNotifications}
                />
              ) : null}
            </Row>
          ) : (
            <Row>
              <Col>
                <h6>Overview </h6>
                <hr />
                <p style={{ textAlign: "left", fontSize: "12px", margin: "0" }}>
                  Total Posts: <strong>{total}</strong>
                </p>
                {candidate.worksheet > 0 ? (
                  <div>
                    <p
                      style={{
                        textAlign: "left",
                        fontSize: "12px",
                        margin: "0",
                        color: "rgb(0, 123, 255)",
                      }}
                    >
                      Worksheets: <strong>{candidate.worksheet}</strong>
                    </p>
                    <p
                      style={{
                        textAlign: "left",
                        fontSize: "12px",
                        color: "#057d21",
                      }}
                    >
                      Other Activities: <strong>{candidate.feeds}</strong>
                    </p>
                    <Progress multi>
                      <Progress animated bar value={worksheets}>
                        {Math.ceil(worksheets) + " %"}
                      </Progress>
                      <Progress animated bar color="success" value={feeds}>
                        {Math.floor(feeds) + " %"}
                      </Progress>
                    </Progress>
                  </div>
                ) : null}

                <hr />
                <Chart
                  style={{ width: "calc(100% + 24px)", marginLeft: "-12px" }}
                  options={this.state.options1}
                  series={this.state.series1}
                  type="bar"
                  height="140"
                />

                <Chart
                  style={{ width: "calc(100% + 24px)", marginLeft: "-12px" }}
                  options={this.state.options2}
                  series={this.state.series2}
                  type="bar"
                  height="160"
                />

                <Chart
                  style={{ width: "calc(100% + 24px)", marginLeft: "-12px" }}
                  options={this.state.options3}
                  series={this.state.series3}
                  type="bar"
                  height="160"
                />
              </Col>
            </Row>
          )}
        </div>
        <Row className="text-center">
          <Col md="12" className=" mb-3">
            <label className="text-muted">
              Download the Lincoln Method App
            </label>
            <br />
            <a
              target="__blank"
              href="https://play.google.com/store/apps/details?id=com.lincolnmethod&pli=1"
            >
              <button className="playStoreBtn">
                <div className="d-flex ">
                  <img className="playBtn my-auto" src={playBtn} />
                  <div>
                    <label className="my-auto">
                      GET IT ON <br /> <span> Google Play</span>
                    </label>
                  </div>
                </div>
              </button>
            </a>
            <a
              target="__blank"
              href="https://apps.apple.com/pk/app/lincoln-method/id6447110097?platform=iphone"
            >
              <button className="playStoreBtn">
                <div className="d-flex">
                  <i className="fa fa-apple my-auto"></i>
                  <div>
                    <label className="my-auto">
                      Download on the <br /> <span> App Store</span>
                    </label>
                  </div>
                </div>
              </button>
            </a>
          </Col>
        </Row>
      </>
    );
  }
}

SideProfileComponent.propTypes = {
  // sendLoginCredentials: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  // loginResponse: state.feedRed.loginResponse,
});

export default connect(mapStateToProps, {})(SideProfileComponent);
